<template>
  <font class="iconfont">&#xe61d;</font>
</template>

<script>
export default {
  name: "v-icon-arrow-left"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/v-icon-arrow-left.vue